import { Component, OnInit } from '@angular/core';
import { GlobalEventsService } from '@shared-data';
import { AlertsService } from 'src/app/shared-data/services/alerts.service';
import { TokenService } from '@auth';

@Component({
  selector: 'app-sync-button',
  templateUrl: './sync-button.component.html',
  styleUrl: './sync-button.component.scss',
})
export class SyncButtonComponent implements OnInit {
  pendingSync: number = 0;

  schedulerVisible: boolean = false;

  constructor(
    private alertService: AlertsService,
    private globalEventsService: GlobalEventsService,
    private tokenService: TokenService,
  ) {}

  async ngOnInit() {
    await this.getAlerts();

    this.globalEventsService.pendingChangesUpdated$.subscribe(async () => {
      await this.getAlerts();
    });
  }

  async getAlerts() {
    const isAvailabilityOnly = await this.tokenService.isAvailabilityOnly();

    this.alertService.getAlerts().subscribe((alerts) => {
      // For AvailabilityOnly users, only show availability changes
      // For other users, show all pending changes
      this.pendingSync = isAvailabilityOnly
        ? alerts.pendingAvailabilityChangesCount
        : alerts.pendingChangesCount;
    });
  }
  hideScheduler() {
    this.schedulerVisible = false;
  }
}
